export default {
  ZH_HK: {
    gd: "自定義",
    en: "系統範本",
    zn: "系統範本",
    voice: "語音"
  },
  EN: {
    gd: "Custom",
    en: "System template",
    zn: "End of period (built-in)",
    voice: "Voice"
  },
  ZH_CN: {
    gd: "自定义",
    en: "系统模板",
    zn: "期末(系统内置)",

    voice: "语音"
  },
  es: {
    gd: "Cantonés",
    en: "Plantilla del sistema",
    zn: "Mandarín",
    voice: "Voz"
  }
};
